import AnnouncementImage from 'shared/images/announcement.webp'
import GalleryImage from 'shared/images/gallery.webp'
import HomeImage from 'shared/images/home.webp'

export const items = [
  {
    id: 'object',
    titleKey: 'kyrgyzstan_block.create_object.intro.items.object.title',
    descriptionKey:
      'kyrgyzstan_block.create_object.intro.items.object.description',
    img: HomeImage,
  },
  {
    id: 'photos',
    titleKey: 'kyrgyzstan_block.create_object.intro.items.photos.title',
    descriptionKey:
      'kyrgyzstan_block.create_object.intro.items.photos.description',
    img: GalleryImage,
  },
  {
    id: 'publish',
    titleKey: 'kyrgyzstan_block.create_object.intro.items.publish.title',
    descriptionKey:
      'kyrgyzstan_block.create_object.intro.items.publish.description',
    img: AnnouncementImage,
  },
]
